import module from 'contabilidad/clientescuentascontables/module.js'

export class ContabilidadClientesCuentasContablesService {
  constructor ($http) {
    this.$http = $http
  }

  obtenerClientes () {
    return this.$http.get('/api/contabilidad/cuentas-contables/clientes', {
      schema: {
        totalCuentasContables: 'number',
      },
    })
  }

  obtenerCuentasContables (idCliente) {
    return this.$http.get('/api/contabilidad/cuentas-contables/cliente/agrupaciones', {
      params: {id_cliente: idCliente},
    })
  }

  agregarCuentasContable (idCliente, data) {
    return this.$http.post('/api/contabilidad/cuentas-contables/cliente/agrupaciones', data, {
      params: {id_cliente: idCliente},
    })
  }

  obtenerCuentaContable (idClienteDestino, idClienteOrigen, idClienteAdministrador, idCuentaBancaria, clasificacion, codigoConcepto) {
    return this.$http.get('/api/contabilidad/cuentas-contables/cliente/agrupacion', {
      params: {
        id_cliente_destino: idClienteDestino,
        id_cliente_origen: idClienteOrigen,
        id_cliente_administrador: idClienteAdministrador,
        id_cuenta_bancaria: idCuentaBancaria,
        clasificacion: clasificacion,
        codigo_concepto: codigoConcepto,
      },
    })
  }

  editarCuentasContable (idClienteDestino, idClienteOrigen, idClienteAdministrador, idCuentaBancaria, clasificacion, codigoConcepto, data) {
    return this.$http.put('/api/contabilidad/cuentas-contables/cliente/agrupacion', data, {
      params: {
        id_cliente_destino: idClienteDestino,
        id_cliente_origen: idClienteOrigen,
        id_cliente_administrador: idClienteAdministrador,
        id_cuenta_bancaria: idCuentaBancaria,
        clasificacion: clasificacion,
        codigo_concepto: codigoConcepto,
      },
    })
  }

  eliminarCuentasContables (data) {
    return this.$http.delete('/api/contabilidad/cuentas-contables/cliente/agrupacion', {
      params: {data},
    })
  }

  obtenerConceptosFacturacion () {
    return this.$http.get('/api/contabilidad/cuentas-contables/catalogo/conceptos-contables')
  }
}

module.service('ContabilidadClientesCuentasContables', ContabilidadClientesCuentasContablesService)



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/services/Contabilidad/ClientesCuentasContables.js